export default class AuthorizationUtils {
    static isUserAllowedToOrder(authentication) {
        if (authentication) {
            const kc = authentication.kc;
            const spocType = authentication.spoc.id.match(/\D+/)[0].toLowerCase();
            return kc.hasRealmRole(`order_${spocType}`);
        }
        return false;
    }

    static isCustomerAllowedToOrder(authentication) {
        if (authentication) {
            return authentication.spoc.contentOrdersAllowed === true;
        }
        return false;
    }

    static isUserAdmin(auth) {
        return auth && auth.kc && (auth.kc.hasRealmRole('connect_admin') || auth.kc.hasRealmRole('connect_admin_demo'));
    }

    static isCatalogueManagementAdmin(auth) {
        return auth && auth.kc && auth.kc.hasRealmRole('catalogue_management_admin');
    }

    static isInPartnerContext(auth) {
        return auth.spoc?.id.includes('PARTNER');
    }
}
